import { KeypointLabel } from "./KeypointLabel";
export default KeypointLabel;
